import { apiSlice } from "../../api/ApiService";

const getPatientRedemptionDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientRedemptionDetails: builder.query({
      query: ({
        accessToken,
        patientProfileId,
      }: {
        accessToken: string | null;
        patientProfileId: string;
      }) => ({
        url: `/api/v1/Administration/${patientProfileId}/patient-redemption-details`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
      providesTags: (result, error, { patientProfileId }) => [
        { type: "PatientRedemptionDetails", id: patientProfileId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientRedemptionDetailsQuery } =
  getPatientRedemptionDetailsApi;
export default getPatientRedemptionDetailsApi;
